import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { Capacitor } from "@/lib/capacitor";
import { App } from "@/lib/capacitor/app";

export function PermissionDeniedCard() {
  const { t } = useTranslation();
  const platform = Capacitor.Platform;

  const platformInstructions =
    platform === "ios"
      ? t("settings.notifications.permission-denied.description.ios", {
          appName: import.meta.env.VITE_APP_NAME || "Boomer",
        })
      : t("settings.notifications.permission-denied.description.android", {
          appName: import.meta.env.VITE_APP_NAME || "Boomer",
        });

  return (
    <div className="dark:bg-red-900/20 mx-4 rounded-lg bg-red-50 p-4">
      <div className="flex gap-3">
        {/* Icon */}
        <div className="shrink-0">
          <div className="dark:bg-red-900/50 flex size-10 items-center justify-center rounded-full bg-red-100">
            <svg
              className="size-6 text-red-600 dark:text-red-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
              />
              <line
                x1="4"
                y1="4"
                x2="20"
                y2="20"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-red-900 dark:text-red-100">
            {t("settings.notifications.permission-denied.title")}
          </h3>
          <p className="mt-1 text-xs text-red-800 dark:text-red-200">{platformInstructions}</p>

          {/* Button */}
          <Button
            size="small"
            className="mt-3 h-9 text-xs"
            onClick={async () => {
              await App.openSettings();
            }}
          >
            {t("settings.notifications.permission-denied.action")}
          </Button>
        </div>
      </div>
    </div>
  );
}
